import { render, staticRenderFns } from "./FundaBNPLJangsa3.vue?vue&type=template&id=2efcd5c3&scoped=true&"
import script from "./FundaBNPLJangsa3.vue?vue&type=script&lang=js&"
export * from "./FundaBNPLJangsa3.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPLJangsa3.vue?vue&type=style&index=0&id=2efcd5c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efcd5c3",
  null
  
)

export default component.exports